<template>
    <div class="topic-of-interest-home-loading">
        <b-row no-gutters>
            <b-col :cols="hasPropertyListings ? 7 : 12">
                <knowledge-asset-loading />

            </b-col>

            <b-col v-if="hasPropertyListings">
                <b-skeleton-img
                    class="map-loader"
                    no-aspect
                />
            </b-col>
        </b-row>
        <b-skeleton no-aspect height="732px" class="mt-4" />
    </div>
</template>

<script>
    import KnowledgeAssetLoading from "./KnowledgeAssetLoading/KnowledgeAssetLoading";
    export default {
        name: "TopicOfInterestHomeLoading",
        components: {KnowledgeAssetLoading},

        data() {
            return {
                hasPropertyListings: window.hasPropertyListings,
            };
        }
    };
</script>

<style scoped>
.map-loader {
    height: calc(100vh - 5rem);
}
</style>
